<template>
  <router-view :defaultHeader="defaultHeader" />
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'TenancyDepositRouter',
  props: {
    defaultHeader: {
      type: String,
      required: true,
    },
  },
});
</script>
